import React, { useEffect, useState } from 'react';
import AdDomainConfig from 'component/setup_component/ad_domain';
import AdGroupConfig from 'component/setup_component/ad_group';
import LicenseConfig from 'component/setup_component/license_config';
import { StepsContent, StepsStyled, StepsWrap, WrapSetUpPage } from './style';
import { useDispatch, useSelector } from 'react-redux';
import { incrementProgress, setCurrent, setupGetLicenseDetails, setupStatus } from 'redux/slices/setupSlice';
import { SubWrapContainer, WrapContainer } from 'component/setup_component/ad_domain/style';
import { Logo } from 'pages/interface/style';
import EmailDelivery from 'component/setup_component/emaildelivery';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { useNavigate } from 'react-router-dom';

const steps = [
  /* {
    title: 'Step 1',
    content: <SqlConfig />,
  }, */
  {
    title: 'Primary Domain',
    content: <AdDomainConfig />,
  },
  {
    title: 'Roles & Groups',
    content: <AdGroupConfig />,
  },
  {
    title: 'Activation',
    content: <LicenseConfig />,
  },
  {
    title: 'Email Delivery',
    content: <EmailDelivery />,
  },
];

const SetUpPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const { current, progress, status, loading } = useSelector((state) => state.setupSlice);

  useEffect(() => {
    const productKeyCheck = async () => {
      const setupStatusValue = await dispatch(setupStatus());
      if (setupStatusValue?.payload.data.domainstatus && setupStatusValue?.payload.data.groupstatus) {
        const productLicense = await dispatch(setupGetLicenseDetails());
        if (productLicense?.payload === 'License details not found.') {
          dispatch(setCurrent(2));
        } else if (productLicense?.payload?.isActived || !productLicense?.payload?.isActived) {
          navigate('/');
        }
      } else if (!setupStatusValue?.payload.data.domainstatus) {
        dispatch(setCurrent(0));
      } else if (!setupStatusValue?.payload.data.groupstatus) {
        dispatch(setCurrent(1));
      }
      setLoader(false);
    };
    productKeyCheck();
  }, []);

  useEffect(() => {
    if (loading) {
      if (progress < 100) {
        const interval = setInterval(() => {
          dispatch(incrementProgress());
        }, 500);
        return () => {
          clearInterval(interval);
        };
      }
    }
  }, [dispatch, progress, loading]);

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  return loader ? (
    <ModalOpenLoader />
  ) : (
    <WrapSetUpPage>
      <WrapContainer>
        <SubWrapContainer>
          <div style={{ textAlign: 'center' }}>
            <Logo className='setupLogo' />
          </div>
          <StepsWrap>
            <StepsStyled current={current} items={items} percent={progress} status={status} />
          </StepsWrap>
          <StepsContent>{steps[current].content}</StepsContent>
        </SubWrapContainer>
      </WrapContainer>
    </WrapSetUpPage>
  );
};

export default SetUpPage;
